<template>
  <div class="rootDiv">
    <div style="background-color: #c5cae0;padding-top: 1rem;padding-bottom: 1rem">
      <div>
        <span style="font-size: 1.8rem">{{ model.bT }}</span>
      </div>
      <div style="margin-top: 10px">
        <span style="font-size: 1.2rem;">{{ model.zZ }}</span>
      </div>
      <div style="font-size: 1.4rem;margin-left: 10px;margin-right: 10px" v-html="model.nR"></div>
    </div>
    <div class="title-div" v-if="model.fL">
      <span>分类</span>
    </div>
    <div style="margin-top: 10px;margin-bottom: 10px">
      <span style="font-size: 1.2rem">{{ model.fL }}</span>
    </div>
    <div class="title-div" v-if="model.jS">
      <span>解释</span>
    </div>
    <div style="margin-left: 10px;margin-right: 10px" v-html="model.jS"></div>
    <div class="title-div" v-if="model.sX">
      <span>赏析</span>
    </div>
    <div style="margin-left: 10px;margin-right: 10px" v-html="model.sX"></div>
  </div>
</template>

<script>
export default {
  name: "ShiCiDetails",
  data() {
    return {
      id: null,
      lb: null,
      model: {
        bT: null,
        fL: null,
        iD: null,
        jS: null,
        lB: null,
        nR: null,
        sX: null,
        zZ: null,
      },
      token: localStorage.getItem('token'),
      getDetailsUrl: '/api/yuanqu/getDetails',
    }
  },
  mounted() {
    if (this.$route.params.id === undefined || this.$route.params.lb === undefined) {
      this.$router.go(-1)
    }
    this.id = this.$route.params.id
    this.lb = this.$route.params.lb
    this.GetDetails()
  },
  methods: {
    GetDetails() {
      let that = this
      let url = that.getDetailsUrl
      that.$ajax({
        method: 'get',
        url: url,
        params: {id: that.id, lb: that.lb},
        headers: {token: that.token, needToken: 'false'}
      }).then((response) => {
            if (!response.data.result)
              that.$messagebox.alert(response.data.message)
            else {
              that.model = response.data['responseData']
            }
          }
      ).catch(response => {
        that.$messagebox.alert(response.request.status === 404 ? "服务器连接失败" : "未知错误，请联系服务商" + response, '服务器异常')
      })
    },
  },
}
</script>

<style lang="less" scoped>
.rootDiv {
  margin-top: -0.5rem;
  margin-left: -0.5rem;
  margin-right: -0.5rem;
}

.title-div {
  background-color: #8450C5;
  padding-top: 5px;
  padding-bottom: 5px;

  span {
    font-size: 1.4rem;
    color: white;
  }
}
</style>
